import { toast } from '@/components/ui/use-toast';

interface PincodeData {
  city: string;
  state: string;
  country: string;
}

export const fetchPincodeDetails = async (pincode: string): Promise<PincodeData | null> => {
  try {
    const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
    const data = await response.json();

    if (data[0].Status === 'Success') {
      const postOffice = data[0].PostOffice[0];
      return {
        city: postOffice.District,
        state: postOffice.State,
        country: 'India'
      };
    }
    return null;
  } catch (error) {
    console.error('Error fetching pincode details:', error);
    toast({
      title: "Error",
      description: "Failed to fetch location details. Please enter manually.",
      variant: "destructive"
    });
    return null;
  }
};